/** Logo de marca: `public/logo-mercadolavictoria.png` (ideal: PNG con transparencia). */
export const MLV_LOGO_SRC = `/logo-mercadolavictoria.png?v=${__MLV_PUBLIC_ASSET_V__}`;

/**
 * @param {'header' | 'hero'} variant
 */
export function mlvLogoImgHtml(variant = 'header') {
  const cls =
    variant === 'hero'
      ? 'h-28 w-auto max-w-[17rem] object-contain mx-auto rounded-2xl'
      : 'h-11 w-auto max-h-[3.25rem] max-w-[min(100%,12rem)] object-contain mx-auto rounded-xl';
  return `<img src="${MLV_LOGO_SRC}" alt="MercadoLaVictoria" class="${cls}" decoding="async" />`;
}

/** Barra superior: logo completo (el wordmark va en la imagen). */
export function mlvLogoAppBarCenter() {
  return `<div class="flex flex-1 flex-col items-center justify-center min-w-0 py-0.5">
    <h1 class="sr-only">MercadoLaVictoria</h1>
    ${mlvLogoImgHtml('header')}
  </div>`;
}
